import {Input, Select} from "antd";
import React, { useRef } from "react";
import {checkValidEngNumbers} from "../core/utils";

const PlateNumber = (props) => {
    const {
        data,
        handleGetPlateNumber,
    } = props;
    const {Option} = Select;
    const list = [
        "الف",
        "ب",
        "پ",
        "ت",
        "ث",
        "ج",
        "چ",
        "ح",
        "خ",
        "د",
        "ذ",
        "ر",
        "ز",
        "ژ",
        "س",
        "ش",
        "ص",
        "ض",
        "ط",
        "ظ",
        "ع",
        "غ",
        "ف",
        "ق",
        "ک",
        "گ",
        "ل",
        "م",
        "ن",
        "و",
        "ه",
        "ی",
    ];
    const firstRef = useRef();
    const thirdRef = useRef();
    const fourthRef = useRef();

    const handleChange = (e, value) => {
        if (
            !value &&
            parseInt(e.target.maxLength) === parseInt(e.target.value.length)
        ) {
            if (e.target.nextElementSibling) e.target.nextElementSibling.focus();
        }
        handleGetPlateNumber({
            number_plate_part_1: firstRef.current.input.value,
            number_plate_part_2: thirdRef.current.input.value,
            number_plate_city_code: fourthRef.current.input.value,
            ...(value && {number_plate_alphabet: value})
        })
    };

    return (
        <div
            className="flex w-100 border-radius-main flex-row flex-row-reverse  flex-items-center bg-color-black-10 px-5">
            {/* {isActive ? ( */}
            <>
                <Input
                    className="w-100 p-1 flex-content-center text-center border-white h-80"
                    inputMode="numeric"
                    type="text"
                    name="first"
                    ref={firstRef}
                    maxLength={2}
                    value={data.number_plate_part_1}
                    onChange={handleChange}
                    onKeyDown={checkValidEngNumbers}
                />
                <Select
                    className="w-50  p-2 flex-content-center flex-items-center text-center border-white plate-number-select-input"
                    name="second"
                    onChange={(value) => handleChange(null, value)}
                    value={data.number_plate_alphabet}
                >
                    {list.map((item) => {
                        return <Option value={item}>{item}</Option>;
                    })}
                </Select>
                <Input
                    className="w-100 flex-content-center text-center border-white h-80"
                    type="text"
                    name="third"
                    ref={thirdRef}
                    maxLength={3}
                    onChange={handleChange}
                    onKeyDown={checkValidEngNumbers}
                    value={data.number_plate_part_2}
                />
                <Input
                    className="w-18  ml-4 flex-content-center text-center border-white h-80"
                    type="text"
                    name="fourth"
                    ref={fourthRef}
                    maxLength={2}
                    onChange={handleChange}
                    onKeyDown={checkValidEngNumbers}
                    value={data.number_plate_city_code}
                />
            </>
            {/* // )
      //  : (
      //   <Input
      //     onClick={() => setIsActive(true)}
      //     placeholder="پلاک"
      //     value={plateNumber}
      //   />
      // )} */}
        </div>
    );
};

export default PlateNumber;
